// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot$slash$dot$dot$slash$dot$dot$slash = require("../../../");
var JsxRuntime = require("react/jsx-runtime");

var make = $dot$dot$slash$dot$dot$slash$dot$dot$slash.TogglesGroup;

var JS = {
  make: make
};

function TogglesGroup__Jsx3(props) {
  var __inline = props.inline;
  var inline = __inline !== undefined ? __inline : false;
  return JsxRuntime.jsx(make, {
              inline: inline,
              children: props.children
            });
}

var make$1 = TogglesGroup__Jsx3;

exports.JS = JS;
exports.make = make$1;
/* make Not a pure module */
